import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";
import { Link } from "react-router-dom";

const HowWeWork = () => {
  const workRef = useRef(null);

  useGSAP(() => {
    gsap.fromTo(workRef.current.querySelectorAll('.work-step'),
      { y: 50, opacity: 0, scale: 0.95 },
      {
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.1,
        scrollTrigger: {
          trigger: workRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      }
    );
  });

  const steps = [
    { title: "Co-create and enable", slug: "co-create-and-enable", iconPath: "/images/cocreate.png" },
    { title: "Innovation", slug: "innovation", iconPath: "/images/inoovate.png" },
    { title: "Data driven strategy", slug: "data-driven-strategy", iconPath: "/images/strategies.png" },
    { title: "Tailored AI solution", slug: "tailored-ai-solution", iconPath: "/images/innovation.png" },
    { title: "Data privacy", slug: "data-privacy", iconPath: "/images/dataprivacy.png" },
    { title: "Ethical AI", slug: "ethical-ai", iconPath: "/images/ethical.png" }
  ];

  return (
    <section ref={workRef} className="py-24 bg-white relative overflow-hidden">
      {/* Subtle Background Accents */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#952877]/5 blur-[120px] rounded-full -z-0"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-[#592aa7]/5 blur-[120px] rounded-full -z-0"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#17091a] mb-6 leading-tight">
            ViconAI Custom <br className="hidden md:block" />
            <span className="bg-gradient-to-r from-[#952877] to-[#592aa7] bg-clip-text text-transparent ">
              Defined Process Execution
            </span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#952877] to-[#592aa7] mx-auto rounded-full"></div>
        </div>

        {/* Process Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <WorkCard key={index} step={step} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

const WorkCard = ({ step, index }) => {
  return (
    <Link 
      to={`/process/${step.slug}`}
      className="work-step group block h-full">
    
      <div className="relative h-full min-h-[300px] flex flex-col items-center justify-center p-10 rounded-[32px] bg-white border border-gray-100 text-center shadow-sm hover:shadow-[0_20px_50px_-12px_rgba(89,42,167,0.15)] transition-all duration-500 cursor-pointer overflow-hidden">
        


        {/* Icon with Floating Effect */}
        <div className="relative w-24 h-24 mb-8 bg-gray-50 rounded-3xl flex items-center justify-center group-hover:scale-110 group-hover:bg-white group-hover:shadow-xl group-hover:shadow-[#952877]/10 transition-all duration-500">
          <img 
            src={step.iconPath} 
            alt={step.title}
            className="w-12 h-12 object-contain z-10"/>
        </div>
        
        <h3 className="text-2xl font-bold text-[#17091a] group-hover:text-[#952877] transition-colors duration-300 px-4">
          {step.title}
        </h3>
        
        {/* Learn More Indicator */}
        <div className="mt-6 flex items-center text-[#592aa7] font-bold text-sm opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
          Learn More 
          <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </div>
        
        {/* Background Hover Tint */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#952877]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      </div>
    </Link>
  );
};

export default HowWeWork;